import { escapeHtml } from "@/utils/sanitizeHtml";

export function getSuccessMessage(data) {
    let message;
    const notDocNumTypes = [
        "Sueldo",
        "Imposiciones",
        "Impuesto Único",
        "Rendición",
        "Boleta",
        "Boleta exenta",
    ];
    let hasDocNumber = !notDocNumTypes.includes(data.obligation_type.name);
    if (hasDocNumber) {
        message = `número <strong>${escapeHtml(data.document_number)}</strong>`;
    } else {
        message = `a nombre de <strong>${escapeHtml(data.counterpart.name)}</strong>`;
    }
    return message;
}
